import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">IATA Validation</h1>
            <p className="mb-0">List of IATA validation</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/iataValidation/view-header.js